export abstract class ZiggeoPlayerConfig {
  public ziggeoToken: string;
}
